/**
 * Generated RTK hooks return the full GraphQL envelope.
 * Domain files pick the nested field once and keep the old hook names,
 * so screens still see the same `data` they had after `transformResponse`.
 */
export type Unwrapped<TResult, TData> = Omit<TResult, 'data' | 'currentData'> & {
  data: TData | undefined;
  currentData: TData | undefined;
};

export function unwrapQuery<TResult, TRaw, TData>(
  result: TResult,
  pick: (raw: TRaw | undefined) => TData | undefined,
): Unwrapped<TResult, TData> {
  const raw = result as TResult & { data?: TRaw; currentData?: TRaw };
  return {
    ...(raw as object),
    data: pick(raw.data),
    currentData: pick(raw.currentData),
  } as Unwrapped<TResult, TData>;
}

/**
 * Lazy-хук отдаёт `[trigger, state]`. Разворачиваем только состояние:
 * его `data` читают как у обычного query. Триггер здесь не трогаем —
 * если промис тоже должен отдавать старую форму, это `unwrapMutation`.
 */
export function unwrapLazyQuery<
  TTuple extends readonly [unknown, unknown, unknown],
  TRaw,
  TData,
>(
  tuple: TTuple,
  pick: (raw: TRaw | undefined) => TData | undefined,
): [TTuple[0], Unwrapped<TTuple[1], TData>, TTuple[2]] {
  const [trigger, state, info] = tuple;
  return [trigger, unwrapQuery(state, pick), info] as [
    TTuple[0],
    Unwrapped<TTuple[1], TData>,
    TTuple[2],
  ];
}

type MutationResult<TRaw> = Promise<{ data?: TRaw; error?: unknown }> & {
  unwrap: () => Promise<TRaw>;
  abort?: () => void;
  reset?: () => void;
  requestId?: string;
};

/**
 * То же, что `unwrapQuery`, но для мутаций и lazy-триггеров, чей результат
 * читают из промиса (`await trigger()`, `trigger().unwrap()`) и из `state.data`.
 */
export function unwrapMutation<TRaw, TData, TPubArg, TState>(
  tuple: readonly [(arg: never) => MutationResult<TRaw>, TState, unknown?],
  pick: (raw: TRaw | undefined) => TData | undefined,
  mapArg?: (arg: TPubArg) => unknown,
): [
  (arg: TPubArg) => Promise<{ data?: TData; error?: unknown }> & {
    unwrap: () => Promise<TData | undefined>;
    abort?: () => void;
    reset?: () => void;
    requestId?: string;
  },
  Unwrapped<TState, TData>,
  unknown,
] {
  const [trigger, state, info] = tuple;

  const wrappedTrigger = (arg: TPubArg) => {
    const original = trigger((mapArg ? mapArg(arg) : arg) as never);
    const next = original.then((result) => ({
      ...result,
      data: pick(result.data),
    })) as Promise<{ data?: TData; error?: unknown }> & {
      unwrap: () => Promise<TData | undefined>;
      abort?: () => void;
      reset?: () => void;
      requestId?: string;
    };

    next.unwrap = () => original.unwrap().then((raw) => pick(raw));
    if (original.abort) next.abort = original.abort.bind(original);
    if (original.reset) next.reset = original.reset.bind(original);
    next.requestId = original.requestId;
    return next;
  };

  return [wrappedTrigger, unwrapQuery(state, pick), info];
}
